import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer id="contatti" className="mt-0 border-t border-[#DED5C3] bg-[#EFE9DC]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-16 py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-baseline gap-3">
            <span className="font-serif text-4xl tracking-tight">Premium</span>
            <span className="overline text-[#A87D4A]">Shoes Care</span>
          </div>
          <p className="mt-2 font-serif text-lg italic text-[#8A6436]">by Mastro Ciabattino Palombi</p>
          <div className="hairline-gold mt-8 mb-6 max-w-[140px]" />
          <p className="max-w-md text-[#5E564C] leading-[1.85] font-light">
            Servizio artigianale italiano di riparazione e restauro per calzature di lusso.
            Dalle Marche, con cura, verso tutta Italia.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-6">Navigazione</div>
          <ul className="space-y-3 text-[#5E564C] text-sm font-light">
            <li><Link to="/servizi" className="hover:text-[#1A1612] transition-colors">Servizi</Link></li>
            <li><Link to="/shop" className="hover:text-[#1A1612] transition-colors">Kit Fai Da Te</Link></li>
            <li><Link to="/ordini" className="hover:text-[#1A1612] transition-colors">Traccia il tuo ordine</Link></li>
            <li><Link to="/accedi" className="hover:text-[#1A1612] transition-colors">Area clienti</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="overline mb-6">Il laboratorio</div>
          <ul className="space-y-3 text-[#5E564C] text-sm font-light">
            <li className="flex items-start gap-3">
              <MapPin size={14} strokeWidth={1.3} className="mt-1 flex-shrink-0 text-[#A87D4A]" />
              <span>Via Indipendenza 50/A<br />63832 Magliano di Tenna (FM)</span>
            </li>
            <li className="flex items-start gap-3">
              <Mail size={14} strokeWidth={1.3} className="mt-1 text-[#A87D4A]" /> info@premiumshoescare.com
            </li>
            <li className="flex items-start gap-3">
              <Instagram size={14} strokeWidth={1.3} className="mt-1 text-[#A87D4A]" /> @mastrociabattino.palombi
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#DED5C3]">
        <div className="max-w-7xl mx-auto px-6 md:px-16 py-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-[0.7rem] text-[#8A8276] uppercase tracking-[0.18em]">
          <div>© {new Date().getFullYear()} Mastro Ciabattino di Palombi Giacomo · P.IVA 02308600440</div>
          <div>Spedizioni SDA · DHL · Pagamenti sicuri</div>
        </div>
      </div>
    </footer>
  );
}
